import { parseErrors, prepareError } from './validationError';

var DEFAULTS = {
    apiRoot: '',
    mutateResponse: null,
    mutateError: null,
    mutateRawResponse: null,
    headers: null,
    cookies: null,
    withCredentials: false,

    parseErrors: parseErrors,
    prepareError: prepareError,

    statusSuccess: [200, 201, 204],
    statusValidationError: [400],

    defaultAcceptHeader: 'application/json'
};

export default DEFAULTS;


//////////////////
// WEBPACK FOOTER
// ../~/tg-resources/es/constants.js
// module id = 411
// module chunks = 0